export interface IGraphGroup {
	id: string;
	displayName: string;
	mail: string;
}

export class SnowUser {
	constructor(
		public sys_id: string = '',
		public name: string = '',
		public firstName: string = '',
		public lastName: string = '',
		public displayName: string = '',
		public employeeNumber: string = '',
		public email: string = '',
		public userName: string = '',
	) {}
}

export class SnowLocation {
	constructor(
		public sys_id: string = '',
		public fullName: string = '',
		public name: string = '',
		public country: string = '',
		public state: string = '',
		public city: string = '',
		public street: string = '',
		public zip: string = '',
		public timeZone: string = '',
	) {}
}

export class SnowCountry {
	constructor(
		public sys_id: string = '',
		public name: string = '',
		public region: string = '',
	) {}
}

export class SnowProfile {
	constructor(
		public sys_id: string = '',
		public userName: string = '',
		public name: string = '',
		public firstName: string = '',
		public lastName: string = '',
		public displayName: string = '',
		public employeeNumber: string = '',
		public email: string = '',
		public manager: SnowUser = new SnowUser(),
		public location: SnowLocation = new SnowLocation(),
		public country: SnowCountry = new SnowCountry(),
	) {}
}

export interface IProfile {
	isProfileComplete: boolean;
	isProfilePartial: boolean;

	isEmployee: boolean;
	isOnLeave: boolean;
	isTerminated: boolean;
	isPending: boolean;

	id: number;
	objectId: string;
	email: string;
	displayName: string;
	jobTitle: string;
	workPhone: string;
	mobilePhone: string;
	office: string;
	location: string;
	aboutMe: string;
	timeZone: string;
	utcOffset: number;
	workingDays: string;
	workingStart: string;
	workingEnd: string;
	department: string;
	country: string;
	flagUrl: string;

	internalDirectCount: number;
	internalReportCount: number;
	externalDirectCount: number;
	externalReportCount: number;

	peer1Email: string;
	peer2Email: string;
	peer3Email: string;
	peer4Email: string;
	peer5Email: string;
	peer1DisplayName: string;
	peer2DisplayName: string;
	peer3DisplayName: string;
	peer4DisplayName: string;
	peer5DisplayName: string;

	responsibilities: Array<string>;
	interests: Array<string>;
	pastProjects: Array<string>;
	// graphGroups: Array<IGraphGroup>;
	snowProfile: SnowProfile;
}

export class Profile implements IProfile {
	constructor(
		public isProfileComplete: boolean = false,
		public isProfilePartial: boolean = false,
		public isEmployee: boolean = false,
		public isOnLeave: boolean = false,
		public isTerminated: boolean = false,
		public isPending: boolean = false,
		public id: number = 0,
		public objectId: string = '',
		public email: string = '',
		public displayName: string = '',
		public jobTitle: string = '',
		public workPhone: string = '',
		public mobilePhone: string = '',
		public office: string = '',
		public location: string = '',
		public aboutMe: string = '',
		public timeZone: string = '',
		public utcOffset: number = 0,
		public workingDays: string = '',
		public workingStart: string = '',
		public workingEnd: string = '',
		public department: string = '',
		public country: string = '',
		public flagUrl: string = '',
		public internalDirectCount: number = 0,
		public internalReportCount: number = 0,
		public externalDirectCount: number = 0,
		public externalReportCount: number = 0,
		public peer1Email: string = '',
		public peer2Email: string = '',
		public peer3Email: string = '',
		public peer4Email: string = '',
		public peer5Email: string = '',
		public peer1DisplayName: string = '',
		public peer2DisplayName: string = '',
		public peer3DisplayName: string = '',
		public peer4DisplayName: string = '',
		public peer5DisplayName: string = '',
		public responsibilities: Array<string> = [],
		public interests: Array<string> = [],
		public pastProjects: Array<string> = [],
		// public graphGroups: Array<IGraphGroup> = [],
		public snowProfile: SnowProfile = new SnowProfile(),
	) {}
}
